<template lang="pug">
div#order-layout
    .p-a.white.lt.box-shadow
        div(v-if="canManageOrderLayout")
            button.float-right.btn.primary(
                type="button",
                @click="submit",
                style="height: 40px;",
                :disabled="onLoading('save-order-layout') || onLoading('fetch-order-layout')"
            )
                v-loading(loader="save-order-layout") Save

            button.float-right.btn.white.m-r-sm(
                type="button",
                @click="cancelEdit",
                style="height: 40px;",
                :disabled="onLoading('save-order-layout') || onLoading('fetch-order-layout')"
            ) Cancel

            button.float-right.btn.white.m-r-sm.m-l-sm(
                type="button",
                style="height: 40px;",
                :disabled="onLoading('save-order-layout') || onLoading('fetch-order-layout')",
                @click="editGrid"
            ) Edit Grid

        p.m-b-0.pull-left.p-t-sm
            breadcrumb

        .clearfix

    template(v-if="!onLoading('fetch-order-layout')")
        .box(v-if="showingUnsavedChanges && canManageOrderLayout")
            .box-body.light-blue-200
                i.material-icons.md-24.m-r-sm &#xe002;
                span Showing unsaved changes.

        .padding.order-layout-container
            .col-md-8
                .row
                    .col-md-12
                        groupNavigation

                .row
                    .col-md-12
                        order-layout-grid
            .col-md-4
                action-menu
        
            edit-grid
            add-product-form(ref="addProduct")
            add-variant-form(ref="addVariant")
            add-promotion-form(v-if="canManagePromotions" ref="addPromotion")
            add-group-form(ref="addGroup")

    p.text-3x.text-center.m-t-lg(v-else)
        v-loading(loader="fetch-order-layout")
</template>

<script>
import orderLayoutGrid from './order-layout-grid.vue';
import editGrid from './order-layout-edit-grid.vue';
import { mapActions, mapGetters } from 'vuex';
import { OrderLayoutEvent } from './order-layout-bus';
import breadcrumb from './order-layout-breadcrumb.vue';
import addProductForm from './order-layout-add-product.vue';
import addVariantForm from './order-layout-add-variant.vue';
import addPromotionForm from './order-layout-add-promotion.vue';
import addGroupForm from './order-layout-add-group.vue';
import actionMenu from './order-layout-action-menu.vue';
import groupNavigation from './order-layout-group-navigation.vue';
import orderLayout from '@js/store/modules/order-layout';
import promotion from '@js/store/modules/promotion';
import PermissionMixin from './order-layout-permission';
import PromotionPermissionMixin from '@js/franchise_component/promotion/mixin/promotion-permissions';

export default {
    components: {
        orderLayoutGrid,
        editGrid,
        breadcrumb,
        addProductForm,
        addVariantForm,
        addGroupForm,
        addPromotionForm,
        actionMenu,
        groupNavigation,
    },

    mixins: [PermissionMixin, PromotionPermissionMixin],

    props: {
        orderLayout: {
            type: Object,
            required: true,
        },

        assignedCentrals: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            showingUnsavedChanges: false,
        };
    },

    computed: {
        ...mapGetters('orderLayout', {
            orderLayoutGetter: 'orderLayout',
            activeGroupPages: 'activeGroupPages',
        }),
    },

    beforeCreate() {
        if (!this.$store._modules.get(['orderLayout']))
            this.$store.registerModule('orderLayout', orderLayout);

        if (!this.$store._modules.get(['promotion']))
            this.$store.registerModule('promotion', promotion);
    },

    created() {
        this.setExcludeCentrals(this.assignedCentrals);
        this.startLoading('fetch-order-layout');
        this.resolveOrderLayout();
        this.getGroupList();
        this.getCentralList();
    },

    mounted() {
        this.createVuexSubscription('orderLayout/setSelectedGrid', grid => {
            if (!_.isNull(grid)) OrderLayoutEvent.$emit('edit-cell', grid);
        });
    },

    methods: {
        async resolveOrderLayout() {
            const orderLayout = await this.getLocalOrderLayout();

            if (!_.isNull(orderLayout)) {
                this.showingUnsavedChanges = true;
                this.viewPage(_.first(this.activeGroupPages));
                this.endLoading('fetch-order-layout');
                return;
            }

            this.fetchOrderLayout();
        },

        ...mapActions('orderLayout', [
            'getOrderLayout',
            'addPage',
            'updateOrderLayout',
            'getGroupList',
            'setSelectedGrid',
            'setExcludeCentrals',
            'viewPage',
            'getLocalOrderLayout',
            'resetLocalOrderLayout',
        ]),
        ...mapActions('central', ['getCentralList']),

        async fetchOrderLayout() {
            try {
                const data = await this.getOrderLayout(this.orderLayout.id);
                if (!data.pages.length) this.addPage({ name: 'Tab 1' });

                this.viewPage(_.first(this.activeGroupPages));
                this.endLoading('fetch-order-layout');
            } catch (e) {
                console.error(e);
            }
        },

        submit() {
            if (this.onLoading('save-order-layout')) return;

            this.setSelectedGrid();
            this.startLoading('save-order-layout');

            this.updateOrderLayout(this.orderLayoutGetter)
                .then(() => {
                    this.endLoading('save-order-layout');
                    this.showingUnsavedChanges = false;
                    swal({
                        type: 'success',
                        title: 'Saved',
                        text: 'Order grid layout has been successfully saved',
                    });
                })
                .catch(e => {
                    this.endLoading('save-order-layout');
                    swal({
                        type: 'error',
                        title: 'Error',
                        text: e,
                    });
                });
        },

        editGrid() {
            OrderLayoutEvent.$emit('edit-grid');
        },

        cancelEdit() {
            this.resetLocalOrderLayout();
            const indexUrl = Laroute.route('franchise.order_layout.index');
            window.location.href = indexUrl;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout.vue